module.exports = __webpack_public_path__ + "img/part-two-thumb.da31495.jpg";